import { render, staticRenderFns } from "./ImpostaPsw.vue?vue&type=template&id=100b47c9&scoped=true&"
import script from "./ImpostaPsw.vue?vue&type=script&lang=js&"
export * from "./ImpostaPsw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "100b47c9",
  null
  
)

export default component.exports